// extracted by css-extract-rspack-plugin
export default {"MPCard":"MPCard-InA41h","mpCard":"MPCard-InA41h","BoxShadowLight":"BoxShadowLight-FjxG6z","boxShadowLight":"BoxShadowLight-FjxG6z"};